import { action } from 'easy-peasy';
import { IActionRemoveMobileUser } from '../types';

const removeMobileUser: IActionRemoveMobileUser = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default removeMobileUser;
